import "./EthosProgressBar";

const EthosProgressBar = ({ percentage, percentageLabel, label, showLabel, width, bgColour = null, link = null }) => {

  if (bgColour === null) {
    if (percentage >= 0 && percentage <= 10) {
      bgColour = "#DA3547"; //Red7
    } else if (percentage > 10 && percentage <= 20) {
      bgColour = "#E67C85"; //Red5
    } else if (percentage > 20 && percentage <= 30) {
      bgColour = "#EB9FA6"; //Red4
    } else if (percentage > 30 && percentage <= 40) {
      bgColour = "#FACD81"; //Amber4
    } else if (percentage > 40 && percentage <= 50) {
      bgColour = "#FFAC00"; //Amber5
    } else if (percentage > 50 && percentage <= 60) {
      bgColour = "#EEA102"; //Amber6
    } else if (percentage > 60 && percentage <= 70) {
      bgColour = "#61D783"; //Green6
    } else if (percentage > 70 && percentage <= 80) {
      bgColour = "#38CD63"; //Green7
    } else if (percentage > 80 && percentage <= 90) {
      bgColour = "#076E24"; //Green8
    } else if (percentage > 90 && percentage <= 100) {
      bgColour = "#076E24"; //Green8
    }
  }

  // if (percentage < 30) {
  //   bgColour = "#DA3547"; // Red
  // } else if (percentage < 70) {
  //   bgColour = "#EEA102"; // Yellow
  // } else {
  //   bgColour = "#38CD63"; // Green
  // }

  // Set label
  let labelHtml;
  if (showLabel === true && link !== null) {
    labelHtml = `
      <div class="labelContainer">
        <a class="progressBarLabel" href=${link} target="_blank">${label}</a>
        <div class="progressBarPercentage">${percentageLabel}</div>
      </div>
    `
  } else if (showLabel === true) {
    labelHtml = `
      <div class="labelContainer">
        <div class="progressBarLabel">${label}</div>
        <div class="progressBarPercentage">${percentageLabel}</div>
      </div>
    `    
  } else {
    labelHtml = ``
  }

  const container = document.createElement("div");

  container.innerHTML = `
    <link
      href="https://fonts.googleapis.com/css2?family=Noto+Sans+Mono"
      rel="stylesheet"
    />
    <link
      href="https://fonts.googleapis.com/css2?family=Inter"
      rel="stylesheet"
    />
    <div
      id="progress-bar-container"
      style="
                    width: ${width}px;
                    ${showLabel === false ? "height:6px" : "height: 72px"}
                "
    >  
        ${labelHtml}
        <div
        id="ethosProgress"
        style="width: ${width}px;"
        >
        <div
          id="theBar"
          style="
                        width: ${percentage}%;
                        background-color: ${bgColour};
                    "
        ></div>
      </div>
    </div>
  `;

  return container;
};
export default EthosProgressBar;
